import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Eyebrow, MaskLine, Reveal } from "./Primitives";
import { Instagram, MessageCircle, MapPin } from "lucide-react";
import { CONTACT, DEFAULT_MSG, waLink } from "../../lib/site";

const FAQ = [
  ["Como funciona a aula experimental?", "É um primeiro treino para você conhecer o método na prática. Conversamos sobre seus objetivos, histórico e rotina, e você sente como é treinar com acompanhamento individual."],
  ["Onde acontecem as aulas presenciais?", `Os atendimentos presenciais acontecem em ${CONTACT.city}. Confirme o local pelo WhatsApp ao agendar.`],
  ["Qual a diferença entre consultoria online e mista?", "Na online, você recebe o treino personalizado e o acompanhamento à distância. Na mista, ele combina aulas presenciais com acompanhamento online entre elas."],
  ["Tem treino específico para mulheres?", "Sim. O treinamento feminino é um dos focos do trabalho, com planos pensados para os objetivos e a rotina de cada aluna."],
  ["Nunca treinei. Posso começar?", "Sim. O plano é montado a partir do seu nível atual, com foco em técnica e progressão segura."],
  ["Quais são os valores?", "Os valores variam conforme a modalidade e a frequência. Envie uma mensagem pelo WhatsApp para receber as opções."],
  ["Como entro em contato?", `WhatsApp: ${CONTACT.whatsappLabel} · Instagram: @${CONTACT.instagram} · ${CONTACT.city}`],
];

export const Faq = () => (
  <section id="faq" className="px-5 py-24 md:px-10 md:py-32" data-testid="faq-section">
    <div className="mx-auto grid max-w-[1400px] gap-14 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Eyebrow index="06">FAQ</Eyebrow>
        <h2 className="mt-8 font-display text-5xl font-900 uppercase leading-[0.9] sm:text-6xl lg:text-8xl">
          <MaskLine inView>Dúvidas</MaskLine>
          <MaskLine inView delay={0.1}><span className="text-[var(--red)]">frequentes.</span></MaskLine>
        </h2>
        <Reveal delay={0.1}>
          <div className="mt-10 space-y-3 border-l-2 border-[var(--red)] pl-5" data-testid="faq-contact-block">
            <a href={waLink(DEFAULT_MSG)} target="_blank" rel="noreferrer" data-testid="faq-contact-whatsapp" className="flex items-center gap-3 text-lg text-zinc-200 transition-colors hover:text-[var(--red)]"><MessageCircle className="h-5 w-5 text-[var(--red)]" /> {CONTACT.whatsappLabel}</a>
            <a href={`https://instagram.com/${CONTACT.instagram}`} target="_blank" rel="noreferrer" data-testid="faq-contact-instagram" className="flex items-center gap-3 text-lg text-zinc-200 transition-colors hover:text-[var(--red)]"><Instagram className="h-5 w-5 text-[var(--red)]" /> @{CONTACT.instagram}</a>
            <div className="flex items-center gap-3 text-lg text-zinc-200" data-testid="faq-contact-location"><MapPin className="h-5 w-5 text-[var(--red)]" /> {CONTACT.city}</div>
          </div>
        </Reveal>
      </div>
      <Reveal className="lg:col-span-7">
        <Accordion type="single" collapsible className="border-t border-white/10" data-testid="faq-accordion">
          {FAQ.map(([q, a], i) => (
            <AccordionItem key={q} value={`q${i}`} className="border-white/10">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} style={{ fontFamily: "'Big Shoulders Display', sans-serif", fontWeight: 800 }} className="py-7 text-left text-2xl uppercase hover:text-[var(--red)] hover:no-underline md:text-3xl">
                {q}
              </AccordionTrigger>
              <AccordionContent className="pb-7 text-base leading-relaxed text-zinc-400">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
